module.exports = new __parcel__URL__("Asana.68a46524.svg").toString();